const formatDate = (dateStr, typeMonth = 'long') =>
  new Intl.DateTimeFormat('es-Es', {
    year: 'numeric',
    month: typeMonth,
    day: '2-digit'
  }).format(new Date(dateStr))

export default formatDate
